import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import data from "../assets/banner7.jpg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection mb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title">
									SOFTWARE DEVELOPMENT
								</h3>
							</div>

							<div className="col-md-12 bg-surface rounded p-3">
								<h5 className="font-semi-bold text-dim py-3">Beside the hardware and network solutions; with design and development expertise in diverse platforms, best-of-breed tools and techniques, combined with industry best practices, BOSTON offers scalable end-to-end application development and management solutions from requirement analysis for deployment and rollout.</h5>
								<img 
									style={{
										width:"100%",
										height:"auto"
									}}
									src={data} 
								/>
								<div>
									<h6 className="font-bold text-light bg-primary rounded p-2 my-3">
										BOSTON ’s services span the following application lifecycle stages:
									</h6>
									<h5
										style={{
											borderLeft:"5px solid var(--primaryColor)",
											padding: "10px"
										}}
									>
										<strong>• APPLICATION DEVELOPMENT</strong> – Providing end-to-end development from requirement analysis for deployment and rollout.<br /><br/>
										<strong>• APPLICATION MAINTENANCE</strong> – Changing or enhancing software to meet changing or increasing business demands in the post-rollout phase of an application<br /><br/>
										<strong>• APPLICATION SUPPORT</strong> – Providing first, second, third line support and on-call support. Oncall support further includes Gold (24x7), Silver and Bronze support.<br /><br/>
										<strong>• APPLICATION INTEGRATION/ MIGRATION/ TRANSFORMATION</strong> – Replacing, migrating and integrating systems.<br /><br/>
										<strong>• APPLICATION MANAGEMENT</strong> – The application management layer cuts across all software engineering activities listed above. BOSTON takes complete ownership of the outsourced suite of applications as per the agreed scope and manages the support.

									</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}